<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
export default {
	data() {
		return {
			//表格筛选
			shaidiag: false,
			headData: JSON.parse(localStorage.getItem('../components/page/MasterDataInformation/AdditionalInformation/informationItems')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('../components/page/MasterDataInformation/AdditionalInformation/informationItems')) || [],
			//表格搜索
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			//表格
			tableHeight: null,
			tableData: [],
			pagination: getdata().pagination,
			tablekey: 0,
			//定义字段
			newfj: false,
			modification: false,
			datatype: '',
			tempName: '',
			options: getdata().options,
			amenddata: {},
			//排序字段名称
			order: '',
			//排序顺序
			sort: ''
		};
	},
	created() {},
	mounted() {
		this.selectfjxx();
	},
	methods: {
		//排序
		sortchange(e) {
			console.log(e);
			this.order = e.prop;
			if (e.order == 'ascending') {
				this.sort = 'ASC';
			} else if (e.order == 'descending') {
				this.sort = 'DESC';
			} else {
				this.sort = '';
			}
			this.selectfjxx();
		},
		deletefjxx() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择数据');
			}
			let params = this.$refs.tablebox
				.getSelectionval()
				.map(v => v.id)
				.join(',');
			this.$https.fetchPost('felec/addInformMaintain/deleteAddInformItems', params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('成功');
					this.pagination.pageNum = 1;
					this.pagination.paginationkey++;
					this.selectfjxx();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		amend() {
			if (!this.tempName) {
				this.$message.error('异常提示:附加信息名称不能为空');
				return;
			}
			if (!this.datatype) {
				this.$message.error('异常提示: 数据类型不能为空');
				return;
			}
			this.amenddata.fujxxmc = this.tempName;
			this.amenddata.shujlx = this.datatype;
			let patea = this.amenddata;
			this.$https.fetchPost('felec/addInformMaintain/updateAddInformItem', patea).then(res => {
				if (res.data.code == '200') {
					this.$message.success('成功');
					this.modification = false;
					this.pagination.pageNum = 1;
					this.pagination.paginationkey++;
					this.selectfjxx();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		uaedte(v) {
			this.modification = true;
			// this.tempName = v.fujxxmc;
			this.tempName = JSON.parse(JSON.stringify(v.fujxxmc));
			// this.datatype = v.shujlx;
			this.datatype = JSON.parse(JSON.stringify(v.shujlx));
			this.amenddata = JSON.parse(JSON.stringify(v));
		},
		Addfjxx() {
			if (!this.tempName) {
				this.$message.error('异常提示:附加信息名称不能为空');
				return;
			}
			if (!this.datatype) {
				this.$message.error('异常提示: 数据类型不能为空');
				return;
			}
			let patea = {
				fujxxmc: this.tempName,
				shujlx: this.datatype
			};
			this.$https.fetchPost('felec/addInformMaintain/addAddInformItem', patea).then(res => {
				if (res.data.code == '200') {
					this.$message.success('成功');
					this.newfj = false;
					this.pagination.pageNum = 1;
					this.pagination.paginationkey++;
					this.selectfjxx();
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		newfjtk() {
			this.tempName = '';
			this.datatype = '';
			this.newfj = true;
		},
		selectfjxx() {
			let patea = {
				limit: this.pagination.pageSize,
				page: this.pagination.pageNum,
				order: this.order,
				sort: this.sort,
				param: JSON.parse(JSON.stringify(this.searchdata))
			};
			this.$https.fetchPost('felec/addInformMaintain/getAddInformItemList', patea).then(res => {
				if (res.data.code == '200') {
					this.pagination.total = res.data.count;
					this.tableData = res.data.data.map(v => {
					if (v.chuangjsj != null) {
						if (v.chuangjsj.length == 8) {
							var reg = /^(\d{4})(\d{2})(\d{2})$/;
							v.chuangjsj = v.chuangjsj.replace(reg, '$1年$2月$3日');
						} else if (v.chuangjsj.length == 14) {
							var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
							v.chuangjsj = v.chuangjsj.replace(reg, '$1年$2月$3日 $4时$5分$6秒');
						}
						if (v.xiugsj.length == 8) {
							var reg = /^(\d{4})(\d{2})(\d{2})$/;
							v.xiugsj = v.xiugsj.replace(reg, '$1年$2月$3日');
						} else if (v.xiugsj.length == 14) {
							var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
							v.xiugsj = v.xiugsj.replace(reg, '$1年$2月$3日 $4时$5分$6秒');
						}
					}
						return v;
					});
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('../components/page/MasterDataInformation/AdditionalInformation/informationItems', JSON.stringify(e.nochooselist));
			localStorage.setItem('../components/page/MasterDataInformation/AdditionalInformation/informationItems', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		},
		//表格搜索
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.selectfjxx();
		},
		//表格分页
		sizechange(e) {
			this.pagination.pageSize = e;
			this.selectfjxx();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.selectfjxx();
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
